import React from 'react';
import { InstagramIcon, NavigationIcon } from 'lucide-react';
import { brand, hours, images } from '../data/site';
export function Visit() {
  const day = new Date().getDay();
  const todayIndex = day === 0 ? 6 : day - 1;
  return <section id="bezoek" className="bg-cream px-6 py-20 lg:py-24" data-id="element-167" data-mp="2i96d03ikzjal">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-2 lg:gap-16" data-id="element-168" data-mp="2n80t2xp5ytr0">
        <div data-id="element-169" data-mp="2999hpj1orm6k">
          <p className="text-sm text-clay" data-id="element-170" data-mp="298hxf4djhavl">Bezoek ons</p>
          <h2 className="mt-4 text-[clamp(2rem,4vw,3.25rem)] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-171" data-mp="29b46j8g2vyfx">
            Burgemeester de Vlugtlaan 198
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-mist" data-id="element-172" data-mp="1zcekd3h5frtv">
            {brand.address[1]} · vlakbij Plein 40-45, met terras in de zon.
          </p>

          <div className="mt-8 flex flex-wrap gap-4" data-id="element-173" data-mp="3tol811r8c132">
            <a href="https://maps.google.com/?q=Burgemeester+de+Vlugtlaan+198+Amsterdam" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 rounded-full bg-ink px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-150 ease-out hover:bg-clay" data-id="element-174" data-mp="3tmrxvcheqyqb">
              <NavigationIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="2u7md3nzo5lmo" /> Route plannen
            </a>
            <a href="https://www.instagram.com/adens.viennoiserie" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 rounded-full border border-ink/20 px-7 py-3.5 text-sm font-medium text-ink transition-colors duration-150 ease-out hover:border-ink" data-id="element-176" data-mp="2q8596yzw4wjm">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="2bftm1z45uahl" /> Instagram
            </a>
          </div>

          <ul className="mt-10 max-w-md" data-id="element-178" data-mp="3mxcss1gy8vkw">
            {hours.map((entry, i) => <li key={entry.day} className={`flex items-center justify-between gap-6 border-b border-ink/10 py-2.5 text-sm ${i === todayIndex ? 'text-ink' : 'text-mist'}`} data-id="element-179" data-mp="3mz63bruonzy6" data-mpi={i}>
                <span className="flex items-center gap-3" data-id="element-180" data-mp="2kivov57rkks0">
                  {entry.day}
                  {i === todayIndex && <span className="rounded-full bg-sand px-2.5 py-0.5 text-xs text-ink" data-id="element-181" data-mp="2ojfocfft80hb">
                      Vandaag
                    </span>}
                </span>
                <span className="tabular-nums" data-id="element-182" data-mp="1ww76yjir8sbe">{entry.time}</span>
              </li>)}
          </ul>
        </div>

        <div className="aspect-[4/5] overflow-hidden rounded-3xl bg-sand lg:aspect-auto lg:min-h-[560px]" data-id="element-183" data-mp="25v0yvwl54uim">
          <img src={images.interior} alt="Interieur van Aden's Viennoiserie met marmeren toonbank" className="h-full w-full object-cover" data-id="element-184" data-mp="2alr67fd4n7fy" />
        </div>
      </div>
    </section>;
}